/* And Friends NZ — assets/af-size-guide.js  (v7)
   Find my size: labels the size system, lifts the trigger when asked, opens
   the drawer, and drives the size converter.

   v6 change — the converter now opens on the column that matches the product's
   gender. On a men's OOFOS "What size do you normally wear?" defaults to
   US Men's rather than whichever column is listed first on the chart. Falls
   back to the first column when the product has no gender set.

   v7 change — the page no longer scrolls behind the open drawer. iOS Safari
   ignores the top layer for touch scrolling, so the body is pinned with
   position:fixed while the drawer is open and the scroll position is restored
   on close. Esc and backdrop clicks are covered too, via the dialog's own
   close event rather than the button handler.

   v5, still here — the size system on the Size label, for the systems named
   in the block setting only. */

(function () {
  'use strict';

  var LIFTED = 'af-sg-block--lifted';

  function text(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function list(v) {
    return String(v || '').split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  /* ── Find the Size label ─────────────────────────────────
     Used both for the system suffix and for placement A. */

  function findSizeLabel(block) {
    var selectors = list(block.dataset.afSgLabelSelector);
    var names = list(block.dataset.afSgOptionNames).map(function (s) {
      return s.toLowerCase();
    });
    if (!names.length) names = ['size'];

    var scope = block.closest('.product, product-info, [data-product-root], main') || document;

    for (var i = 0; i < selectors.length; i++) {
      var nodes;
      try { nodes = scope.querySelectorAll(selectors[i]); } catch (e) { continue; }
      for (var j = 0; j < nodes.length; j++) {
        var label = text(nodes[j]).toLowerCase().replace(/[:\u2014\u2013-].*$/, '').trim();
        for (var k = 0; k < names.length; k++) {
          if (label === names[k] || label.indexOf(names[k]) === 0) {
            return nodes[j];
          }
        }
      }
    }
    return null;
  }

  /* ── System suffix ───────────────────────────────────────
     "Size" becomes "Size — UK". Only for systems named in the block setting,
     so Alpha, Unisex and Sock never appear. Idempotent — re-running never
     doubles the suffix. */

  function labelSystem(block, sg) {
    var system = (sg.dataset.afSgSystem || '').trim();
    if (!system) return;

    var allowed = list(block.dataset.afSgLabelSystems).map(function (s) {
      return s.toLowerCase();
    });
    if (allowed.indexOf(system.toLowerCase()) === -1) return;

    var label = findSizeLabel(block);
    if (!label) return;

    if (label.querySelector('.af-sg__system')) return;
    if (text(label).toLowerCase().indexOf(system.toLowerCase()) !== -1) return;

    var span = document.createElement('span');
    span.className = 'af-sg__system';
    span.textContent = ' \u2014 ' + system;
    label.appendChild(span);
  }

  function lift(block, sg) {
    if (block.dataset.afSgPlacement !== 'label_row') return;
    var label = findSizeLabel(block);
    if (!label) return;
    label.classList.add('af-sg-in-label');
    label.appendChild(sg);
    block.classList.add(LIFTED);
  }

  /* ── Converter ───────────────────────────────────────── */

  function esc(v) {
    if (window.CSS && CSS.escape) return CSS.escape(v);
    return String(v).replace(/["\\]/g, '\\$&');
  }

  function columnValues(table, column) {
    var cells = table.querySelectorAll('tbody td[data-af-sg-cell="' + esc(column) + '"]');
    var out = [];
    for (var i = 0; i < cells.length; i++) {
      var v = text(cells[i]);
      if (v && v !== '\u2014' && v !== '-' && out.indexOf(v) === -1) out.push(v);
    }
    return out;
  }

  function clearMatch(table) {
    var prev = table.querySelectorAll('tr[data-af-sg-match]');
    for (var i = 0; i < prev.length; i++) prev[i].removeAttribute('data-af-sg-match');
  }

  function matchRow(table, column, value) {
    clearMatch(table);
    if (!value) return null;
    var cells = table.querySelectorAll('tbody td[data-af-sg-cell="' + esc(column) + '"]');
    for (var i = 0; i < cells.length; i++) {
      if (text(cells[i]) === value) {
        var row = cells[i].closest('tr');
        row.setAttribute('data-af-sg-match', '');
        row.scrollIntoView({ block: 'nearest' });
        return row;
      }
    }
    return null;
  }

  function describe(table, row, fromColumn) {
    var heads = table.querySelectorAll('thead th[data-af-sg-col]');
    var parts = [];
    for (var i = 0; i < heads.length; i++) {
      var col = heads[i].getAttribute('data-af-sg-col');
      if (col === fromColumn) continue;
      var cell = row.querySelector('td[data-af-sg-cell="' + esc(col) + '"]');
      if (!cell) continue;
      var v = text(cell);
      if (!v || v === '\u2014' || v === '-') continue;
      parts.push(col + ' ' + v);
    }
    return parts.join(', ');
  }

  /* Pick the dropdown option matching the product's gender. "Women's" also
     contains "men", so women is tested first and men explicitly excludes it. */
  function preselect(sg, from) {
    var gender = (sg.dataset.afSgGender || '').toLowerCase();
    if (gender !== 'mens' && gender !== 'womens') return;

    for (var i = 0; i < from.options.length; i++) {
      var label = from.options[i].value.toLowerCase();
      var hit = gender === 'womens'
        ? label.indexOf('women') !== -1
        : (label.indexOf('men') !== -1 && label.indexOf('women') === -1);
      if (hit) { from.selectedIndex = i; return; }
    }
  }

  function initConverter(sg) {
    var wrap = sg.querySelector('[data-af-sg-convert]');
    var table = sg.querySelector('[data-af-sg-table]');
    if (!wrap || !table) return;

    var from = wrap.querySelector('[data-af-sg-from]');
    var value = wrap.querySelector('[data-af-sg-value]');
    var result = wrap.querySelector('[data-af-sg-result]');
    if (!from || !value) return;

    function fillValues() {
      var vals = columnValues(table, from.value);
      value.innerHTML = '';
      var blank = document.createElement('option');
      blank.value = '';
      blank.textContent = 'Select\u2026';
      value.appendChild(blank);
      for (var i = 0; i < vals.length; i++) {
        var o = document.createElement('option');
        o.value = vals[i];
        o.textContent = vals[i];
        value.appendChild(o);
      }
      if (result) result.textContent = '';
      clearMatch(table);
    }

    function apply() {
      var row = matchRow(table, from.value, value.value);
      if (!row) { if (result) result.textContent = ''; return; }
      var rest = describe(table, row, from.value);
      if (result) {
        result.innerHTML = 'That\u2019s <strong>' + from.value + ' ' + value.value + '</strong>' +
          (rest ? ' \u2014 ' + rest : '') + '.';
      }
    }

    from.addEventListener('change', fillValues);
    value.addEventListener('change', apply);

    preselect(sg, from);
    fillValues();
    wrap.hidden = false;
  }

  /* ── Body scroll lock ────────────────────────────────────
     position:fixed on the body is the only technique iOS Safari honours.
     scrollY is captured on open and restored on close, otherwise the page
     jumps to the top. Reference-counted so two drawers on one page cannot
     unlock each other. */

  var lockCount = 0;
  var lockedY = 0;

  function lockScroll() {
    if (lockCount++ > 0) return;
    lockedY = window.scrollY || window.pageYOffset || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = (-lockedY) + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    document.documentElement.classList.add('af-sg-open');
  }

  function unlockScroll() {
    if (--lockCount > 0) return;
    lockCount = 0;
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    document.documentElement.classList.remove('af-sg-open');
    window.scrollTo(0, lockedY);
  }

  /* ── Drawer ──────────────────────────────────────────── */

  function initDialog(sg) {
    var dialog = sg.querySelector('[data-af-sg-dialog]');
    var open = sg.querySelector('[data-af-sg-open]');
    var close = sg.querySelector('[data-af-sg-close]');
    if (!dialog || !open) return;

    open.addEventListener('click', function (e) {
      e.preventDefault();
      if (dialog.open) return;
      lockScroll();
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      /* Always start at the top so the table header and the close button are
         the first things in view. */
      var body = sg.querySelector('.af-sg__body');
      if (body) body.scrollTop = 0;
    });

    /* Fires for the close button, Esc and the backdrop alike. */
    dialog.addEventListener('close', function () { unlockScroll(); });

    if (close) {
      close.addEventListener('click', function () {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      });
    }

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog && typeof dialog.close === 'function') dialog.close();
    });
  }

  /* ── Boot ────────────────────────────────────────────── */

  function init(root) {
    var blocks = (root || document).querySelectorAll('[data-af-sg-block]');
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      if (block.dataset.afSgReady === 'true') continue;

      var sg = block.querySelector('[data-af-sg]');
      if (!sg) { block.dataset.afSgReady = 'true'; continue; }

      initDialog(sg);
      initConverter(sg);
      labelSystem(block, sg);
      lift(block, sg);

      block.dataset.afSgReady = 'true';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function () { init(); });
})();